import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import CategoryView from './views/Category.vue'
import CollectionView from './views/Collection.vue'
import ItemView from './views/Item.vue'
import ShoppingCart from './views/ShoppingCart.vue'
import Checkout from './views/Checkout.vue'
import OrderSuccess from './views/OrderSuccess.vue'
import OrderError from './views/OrderError.vue'
import Agb from './views/Agb.vue'
import Privacy from './views/Privacy.vue'
import Imprint from './views/Imprint.vue'

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/',  name: 'Home', component: Home },
    { path: '/category/:id',  name: 'Category', component: CategoryView },
    { path: '/collection/:id',  name: 'Collection', component: CollectionView },
    { path: '/item/:id',  name: 'Item', component: ItemView },
    { path: '/cart',  name: 'Cart', component: ShoppingCart },
    { path: '/checkout',  name: 'Checkout', component: Checkout },
    { path: '/success',  name: 'Success', component: OrderSuccess },
    { path: '/error',  name: 'Error', component: OrderError },
    { path: '/agb',  name: 'Agb', component: Agb },
    { path: '/privacy',  name: 'Datenschutz', component: Privacy },
    { path: '/imprint',  name: 'Imprint', component: Imprint },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 60 }
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
